import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppNavContent from "./AppNavContent"; // AppNav is mounted as its own standalone react_component root on every
// non-SPA page (the my_rift SPA renders AppNavContent directly as part of
// its own tree/router instead - see templates/MyRiftTemplate.js). This
// wrapper just gives AppNavContent a real <Router> ancestor so react-router's
// useLocation (used by Nav for active-link state, and by AppNavContent to
// close the panel on navigation) doesn't throw outside of one.
//
// Since there's no <Routes> tree here (this is a standalone root, not the
// SPA), AppNavContent/Nav/NavList/Logo deliberately do NOT get asRouterLink
// passed here - it defaults to false, so they render plain <a href> links
// (real full-page navigation) instead of react-router <Link>s, which would
// otherwise just silently rewrite the URL via pushState with no matching
// route to render new content. See templates/MyRiftTemplate.js for the
// asRouterLink: true (in-SPA, client-side nav) counterpart.
export default function AppNav(props) { return /*#__PURE__*/ React.createElement(BrowserRouter, null, /*#__PURE__*/ React.createElement(AppNavContent, props)); }
